import { render, staticRenderFns } from "./indexSize.vue?vue&type=template&id=5ff274d4&"
import script from "./indexSize.vue?vue&type=script&lang=ts&"
export * from "./indexSize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports